export const TYPES = {
  DEFAULT: 'default',
  CENTERED: 'centered'
}
